<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-title>Information</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content :fullscreen="true">
      <ion-header collapse="condense">
        <ion-toolbar>
          <ion-title size="large">Information</ion-title>
        </ion-toolbar>
      </ion-header>
      <information />
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
} from "@ionic/vue";

import Information from "@/components/Information.vue";

export default {
  name: "Tab3",
  components: { IonHeader, IonToolbar, IonTitle, IonContent, IonPage, Information },
};
</script>
